import { Col, Modal, Row, Steps, message } from 'antd';
import { useState } from 'react';

import RegisterFAComponent1 from '../../components/financial-asset/RegisterFAComponent1';
import RegisterFAComponent2 from './RegisterFAComponent2';
import RegisterFAComponent3 from './RegisterFAComponent3';
import RegisterFAComponent4 from './RegisterFAComponent4';

const { Step } = Steps;
const steps = [
  {
    title: '카드종류 선택',
  },
  {
    title: '카드사 선택',
  },
  {
    title: '카드사 로그인',
  },
  {
    title: '카드 등록',
  },
];

interface RegisterFAModalProps {
  visible: boolean;
  existedFAList: any[];
  _getMyAssetList: (data: any) => void;
  _createFinancialAsset: (result: any[]) => void;
  onCreate: () => void;
  onCancel: () => void;
}

function RegisterFAModal({
  visible,
  existedFAList,
  _getMyAssetList,
  _createFinancialAsset,
  onCreate,
  onCancel,
}: RegisterFAModalProps) {
  const [step, setStep] = useState(0);
  const [step1Data, setStep1Data] = useState<any>();
  const [step2Data, setStep2Data] = useState<any>();
  const [financialAsset, setFinancialAsset] = useState<any[]>([]);

  const step1OnNext = (data: any) => {
    setStep1Data(data);
    setStep(step + 1);
  };

  const step2OnPrev = () => {
    setStep(step - 1);
  };
  const step2OnNext = (data: any) => {
    setStep2Data(data);
    setStep(step + 1);
  };

  const step3OnPrev = () => {
    setStep(step - 1);
  };
  const step3OnNext = async (_data: any) => {
    const data = {
      id: _data.id,
      password: _data.password,
      ...step1Data,
      ...step2Data,
    };
    if (_data.clientTypeLevel) {
      data.clientTypeLevel = _data.clientTypeLevel;
    }
    if (_data.loginTypeLevel) {
      data.loginTypeLevel = _data.loginTypeLevel;
    }
    const fa: any = await _getMyAssetList({
      ...data,
    });
    if (fa.success) {
      for (let i = 0; i < fa.data.length; i++) {
        let disabled = false;
        for (const existedFA of existedFAList) {
          if (fa.data[i].number === existedFA.number) disabled = true;
        }
        fa.data[i].disabled = disabled;
      }
      setFinancialAsset(fa.data);

      /**
       * add loginTypeLevel, clientTypeLevel
       */
      delete _data.id;
      delete _data.password;
      setStep1Data({ ...step1Data, ..._data });
      setStep(step + 1);
    } else {
      message.error('로그인 실패 하였습니다.');
    }

    // setFinancialAsset([
    //   { id: 1, name: 'KB카드', number: '3230-23434-234', isRegistered: false },
    //   { id: 2, name: 'KB카드', number: '3230-23434-32423', isRegistered: true },
    // ]);
  };
  const step4OnPrev = () => {
    setStep(step - 1);
  };
  const step4OnNext = async (financialAssetList: any[]) => {
    const result: any[] = [];
    for (const financialAsset of financialAssetList) {
      result.push({
        ...step1Data,
        ...step2Data,
        ...financialAsset,
        assetType: '0',
      });
    }
    await _createFinancialAsset([...result]);
  };

  return (
    <>
      <Modal
        visible={visible}
        title="카드 등록"
        okText="확인"
        cancelText="취소"
        width={900}
        onCancel={onCancel}
        onOk={onCreate}
        footer={null}
      >
        <Row justify="center" style={{ marginBottom: '50px' }}>
          <Col span={18}>
            <Steps current={step}>
              {steps.map((item) => (
                <Step key={item.title} title={item.title} />
              ))}
            </Steps>
          </Col>
        </Row>
        {step === 0 && <RegisterFAComponent1 onCreate={step1OnNext} />}
        {step === 1 && (
          <RegisterFAComponent2 onPrev={step2OnPrev} onNext={step2OnNext} />
        )}
        {step === 2 && (
          <RegisterFAComponent3
            clientType={step1Data.clientType}
            organizationCode={step2Data.organizationCode}
            onPrev={step3OnPrev}
            onNext={step3OnNext}
          />
        )}
        {step === 3 && financialAsset !== undefined && (
          <RegisterFAComponent4
            onPrev={step4OnPrev}
            onNext={step4OnNext}
            financialAsset={financialAsset}
          />
        )}
      </Modal>
    </>
  );
}

export default RegisterFAModal;
